module.exports = __webpack_public_path__ + "static/media/ecommerce.37b2dff9.png";